import { Tooltip } from "antd";
import Image from "next/image";
import { useIntl } from "react-intl";
import {
  formatDayAndMonthByLocale,
  getImageUrl,
  translateDuration,
} from "../../../Lib/Utils/validationUtil";
import { useRecState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { trainType, TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { ISelectedTrainLegs } from "../../../Orchestrator/Types/Index";
import "./train-info-card.css";
import stopManager from "../../../Lib/Utils/StopManager";

const TripSummaryTrainInfoCard: React.FC<{
  type: TrainTypeEnum.outbound | TrainTypeEnum.inbound;
  screen?: string;
}> = ({ type, screen }) => {
  const [selectedTrainLegs] = useRecState<ISelectedTrainLegs>(
    "selectedTrainLegsAtom"
  );
  const intl = useIntl();
  return (
    <>
      {selectedTrainLegs[type]?.length > 0 &&
        selectedTrainLegs[type].map((train, index) => {
          if (screen === "serviceRequest") {
            return (
              <div className="station-summary-card-rc" key={index}>
                <div className="station_icon">
                  <Image
                    src={
                      type === TrainTypeEnum.outbound
                        ? "/assets/booking/arrow_forward.svg"
                        : "/assets/booking/arrow_backward.svg"
                    }
                    width={15}
                    height={15}
                    alt={type}
                  />
                </div>
                <div className="station_content">
                  <div className="train-destinations ff-inter">
                    {stopManager.getStopNameById(train.fromName, train.fromDisplayName || train.fromName)}
                    <span className="d-flex">
                      <Image
                        src="/assets/booking/arrow-right.svg"
                        width={20}
                        height={20}
                        alt="Station-Icon"
                      />
                    </span>
                    {stopManager.getStopNameById(train.toName, train.toDisplayName || train.toName)}
                  </div>
                  <div className="train_time align-items-center gap-2">
                    <span className="mr-10">{formatDayAndMonthByLocale(train.shortStartDateFormat)}</span>
                    <span>
                      {train.departureTime} - {train.arrivalTime}
                    </span>
                  </div>
                </div>
              </div>
            );
          }
          return (
            <div key={index}>
            <div className="station_summary_card">
              <div className="station_icon">
                <Image
                  src={getImageUrl(train.trainType)}
                  width={26}
                  height={26}
                  alt="Icon"
                />
              </div>
              <div className="station_content">
                <div className="train_destinations">
                  <Tooltip
                    className="title-overflow"
                    title={stopManager.getStopNameById(train.fromName, train.fromDisplayName || train.fromName)}
                  >
                    {stopManager.getStopNameById(train.fromName, train.fromDisplayName || train.fromName)}
                  </Tooltip>
                  <span>
                    <Image
                      src="/assets/booking/arrow-right.svg"
                      width={20}
                      height={20}
                      alt="Station-Icon"
                    />
                  </span>
                  <Tooltip
                    className="title-overflow"
                    title={stopManager.getStopNameById(train.toName)}
                  >
                    {stopManager.getStopNameById(train.toName, train.toDisplayName || train.toName)}
                  </Tooltip>
                </div>
                <div className="train_time">
                  {train.departureTime} - {train.arrivalTime}
                </div>
                <div className="train_info">
                  {translateDuration(train.duration, intl)}
                  <span>&bull;</span>
                  {train.trainNo}
                </div>
              </div>
            </div>
            {train?.trainType == trainType.shuttle && <div className="summary-text">{intl.formatMessage({ id: "shuttlePriceForAll" })}</div>}
            </div>
          );
        })}
    </>
  );
};

export default TripSummaryTrainInfoCard;
